// Module
var code = "<span class=\"ndd-ng-form-internal-error\"> <span class=\"ndd-ng-form-internal-error__message\">{{ errorMessage }}</span> </span> ";
// Exports
module.exports = code;